
import XButton from 'vux/src/components/x-button/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'


export default {
components: {
XButton,
GroupTitle,
XDialog
},
data() {
return {
showQr: false,
qrCode: '',
hasNoUserCard: true
}
},
mounted: function () {
document.title = '个性名片'
this.$nextTick(function () {
this.$vux.loading.show('数据加载中')
this.$http.get(this.tianYiWebUrl + '/wechat/uc/ajaxUserCard').then(r => {
if (r.data.code === 200) {
this.hasNoUserCard = r.data.data
}
});
this.$vux.loading.hide()
})
},
methods: {
showQrHandler() {
this.$vux.loading.show('获取中')
this.$http.get(this.tianYiWebUrl + '/wechat/uc/showQrCode').then(r => {
if (r.data.code === 500) {
this.$vux.alert.show({
title: '提示',
content: r.data.message
})
}
if (r.data.code === 200) {
this.qrCode = r.data.data;
this.showQr = true;
}
this.$vux.loading.hide();
})
},
showUserCard() {
this.$vux.loading.show('获取中')
this.$http.get(this.tianYiWebUrl + '/wechat/uc/showUserCard').then(r => {
if (r.data.code === 500) {
this.$vux.loading.hide();
this.$vux.alert.show({
title: '提示',
content: r.data.message
})
}
if (r.data.code === 200) {
this.qrCode = r.data.data;
this.showQr = true;
}
this.$vux.loading.hide();
})
}
}
};



// WEBPACK FOOTER //
// ./src/components/uc/ReferImgIndex.vue